import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydroquinoneCycleGlyphSecondary from './svgs/HydroquinoneCycleGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydroquinoneCycleGlyph = (props => useIcon(null, SvgHydroquinoneCycleGlyphSecondary, props));

export { hydroquinoneCycleGlyph as default };
